import React, { FC, useCallback } from "react";

import { defineMessages, useIntl } from "react-intl";

import RoundButton from "@app/component/RoundButton";
import useAnalytics from "@app/util/contexts/useAnalytics";

const messages = defineMessages({
  title: {
    id: "onboarding.guides.filters.unassigned.title",
    defaultMessage: "Unassigned",
    description: "Title of the Unassigned filter button on the Guides page",
  },
});

export interface UnassignedFilterProps {
  active: boolean;
  onToggle: (active: boolean) => void;
}

const UnassignedFilter: FC<UnassignedFilterProps> = ({ active, onToggle }) => {
  const intl = useIntl();
  const analytics = useAnalytics();

  const handleClick = useCallback(() => {
    analytics.using(["Unassigned Filter"]);
    onToggle(!active);
  }, [analytics, active, onToggle]);

  return (
    <RoundButton active={active} onClick={handleClick}>
      {intl.formatMessage(messages.title)}
    </RoundButton>
  );
};

export default UnassignedFilter;
